import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const AddGoalRaceModal = ({ onClose, onCreated, race }) => {
  const { authFetch } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isEditMode = !!race;

  const [formData, setFormData] = useState({
    custom_name: race?.custom_name || '',
    distance: race?.distance || '5k',
    race_date: race?.race_date || '',
    target_time: race?.target_time || '',
    notes: race?.notes || '',
    is_primary: race?.is_primary || false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const url = isEditMode ? `/api/races/goals/${race.id}` : '/api/races/goals';
      const method = isEditMode ? 'PUT' : 'POST';

      const res = await authFetch(url, {
        method,
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        onCreated();
      } else {
        const data = await res.json();
        setError(data.detail || `Failed to ${isEditMode ? 'update' : 'add'} goal race`);
      }
    } catch (err) {
      setError(`Failed to ${isEditMode ? 'update' : 'add'} goal race`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isEditMode ? 'Edit Goal Race' : 'Add Goal Race'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}

          <div className="form-group">
            <label>Race Name</label>
            <input
              type="text"
              name="custom_name"
              value={formData.custom_name}
              onChange={handleChange}
              placeholder="e.g., London Marathon 2025"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Distance</label>
              <select
                name="distance"
                value={formData.distance}
                onChange={handleChange}
              >
                <option value="5k">5K</option>
                <option value="10k">10K</option>
                <option value="half_marathon">Half Marathon</option>
                <option value="marathon">Marathon</option>
                <option value="ultra">Ultra</option>
              </select>
            </div>

            <div className="form-group">
              <label>Race Date</label>
              <input
                type="date"
                name="race_date"
                value={formData.race_date}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Target Time (optional)</label>
            <input
              type="text"
              name="target_time"
              value={formData.target_time}
              onChange={handleChange}
              placeholder="e.g., 3:30:00"
            />
          </div>

          <div className="form-group">
            <label>Notes (optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Any notes about this race..."
              rows={2}
            />
          </div>

          <div className="form-group form-checkbox">
            <label>
              <input
                type="checkbox"
                name="is_primary"
                checked={formData.is_primary}
                onChange={handleChange}
              />
              <span>Set as primary goal race</span>
            </label>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading
                ? (isEditMode ? 'Saving...' : 'Adding...')
                : (isEditMode ? 'Save Changes' : 'Add Goal Race')
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGoalRaceModal;
